import { render, staticRenderFns } from "./PlansCard.vue?vue&type=template&id=35c2de62&scoped=true"
import script from "./PlansCard.vue?vue&type=script&lang=js"
export * from "./PlansCard.vue?vue&type=script&lang=js"
import style0 from "./PlansCard.vue?vue&type=style&index=0&id=35c2de62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c2de62",
  null
  
)

export default component.exports